var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("ChatView")]),_vm._v(" "),_c('ChatbotWrapper',{attrs:{"context":{ jsonData: _vm.mockContext, firstMessage: 'Your portfolio sucks' },"socketPath":"/ws/agent-chat/"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }